export default __webpack_public_path__ + "images/cdda98ee3282b537b53a0cfb94b32d8d-comedy_desktop-2.webp";